export const provinceOptions = {
	antwerpen: 'Antwerpen',
	limburg: 'Limburg',
	oost_vlaanderen: 'Oost-Vlaanderen',
	vlaams_brabant: 'Vlaams-Brabant',
	west_vlaanderen: 'West-Vlaanderen'
}
